import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { AprListState } from "@reducers/types/HRM/apr-list-state";

import { getAprListRequest } from "@actions/HRM/apr/apr-list-actions";
import { getAprListState } from "@selectors/HRM/apr/apr-list-selectors";

import { useAppSelector } from "@helpers/redux";
import { PaginationType } from "@type/HRM/pagination";
import { AprListResponseType, AprType } from "@type/HRM/aprs";

interface UseAprList {
  aprListRequest: boolean;
  aprListSuccess: boolean;
  aprListFailed: boolean;
  aprList: AprType[];
  pagination: PaginationType;
  year: number;
  handleQuery: (key: string, value: number | boolean) => void;
}

export const useApr = (): UseAprList => {
  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    year: new Date().getFullYear(),
  });

  const handleQuery = (key: string, value: number | boolean) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const getAprList = useAppSelector<AprListState>(getAprListState);

  const aprListRequest = getAprList.request as boolean;
  const aprListSuccess = getAprList.success as boolean;
  const aprListFailed = getAprList.failed as boolean;

  const { data: aprList, pagination } = getAprList.data
    ? getAprList.data
    : ({} as AprListResponseType);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAprListRequest(query));
  }, [dispatch, query]);

  return {
    year: query.year,
    handleQuery,
    aprListRequest,
    aprListSuccess,
    aprListFailed,
    aprList,
    pagination,
  };
};
